import { API_URL } from "../service.config";
import info from "../../utils/info";

export default {
  getTerms(lang: string) {
    return API_URL.get(`/language?iso=${lang}`);
  },
  getLanguages() {
    return API_URL.get(`/language/all`);
  },
  getFixedTerms(pagination: any) {
    return API_URL.get(
      `/language/fixed-terms?start=${pagination.start}&quantity=${pagination.quantity}`,
      {
        headers: {
          Authorization: `Bearer ${info.getToken()}`
        }
      }
    );
  },
  updateFixedTerm(term: any) {
    return API_URL.put(`/language`, term, {
      headers: {
        Authorization: `Bearer ${info.getToken()}`
      }
    });
  }
};
